(function () {
  const selector = '[data-blog-anchor-nav]';

  function getHeaderOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    const parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getNavHeight(root) {
    return root.offsetHeight || 0;
  }

  function updateNavHeight(root) {
    const height = `${getNavHeight(root)}px`;
    root.style.setProperty('--blog-anchor-nav-height', height);
    document.documentElement.style.setProperty('--blog-anchor-nav-height', height);
  }

  function getLinks(root) {
    return Array.from(root.querySelectorAll('[data-anchor-link]'));
  }

  function resolveHref(link) {
    return (link.getAttribute('href') || '').trim();
  }

  function getTarget(href) {
    if (!href || href.charAt(0) !== '#' || href === '#') return null;
    try {
      return document.querySelector(href);
    } catch (error) {
      return null;
    }
  }

  function setActiveLink(root, activeLink) {
    getLinks(root).forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    if (activeLink && window.innerWidth < 990) {
      activeLink.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }

  function scrollToHref(root, href) {
    if (!href || href.charAt(0) !== '#') return false;

    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return true;
    }

    const target = getTarget(href);
    if (!target) return false;

    const top =
      target.getBoundingClientRect().top +
      window.scrollY -
      getHeaderOffset() -
      getNavHeight(root) -
      12;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth',
    });

    return true;
  }

  function updateActiveFromScroll(root) {
    if (root._anchorLock) return;

    const offset = getHeaderOffset() + getNavHeight(root) + 16;
    const links = getLinks(root);
    let current = null;

    links.forEach((link) => {
      const href = resolveHref(link);
      const target = getTarget(href);
      if (!target) {
        if (!current && (href === '#' || href === '')) current = link;
        return;
      }
      if (target.getBoundingClientRect().top <= offset) current = link;
    });

    if (!current) current = links[0];
    if (current) setActiveLink(root, current);
  }

  function bindEvents(root) {
    if (root.dataset.anchorBound === 'true') return;
    root.dataset.anchorBound = 'true';

    getLinks(root).forEach((link) => {
      link.addEventListener('click', function (event) {
        const href = resolveHref(this);
        setActiveLink(root, this);
        root._anchorLock = true;

        if (scrollToHref(root, href)) {
          event.preventDefault();
          if (href !== '#' && history.replaceState) {
            history.replaceState(null, '', href);
          } else if (href === '#' && history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        }

        window.setTimeout(function () {
          root._anchorLock = false;
        }, 700);
      });
    });

    window.addEventListener(
      'scroll',
      function () {
        if (root._scrollTick) return;
        root._scrollTick = true;
        window.requestAnimationFrame(function () {
          updateNavHeight(root);
          updateActiveFromScroll(root);
          root._scrollTick = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      updateNavHeight(root);
      updateActiveFromScroll(root);
    });
  }

  function initRoot(root) {
    if (!root) return;

    updateNavHeight(root);
    bindEvents(root);

    const hash = window.location.hash;
    const hashMatch = hash ? root.querySelector(`[data-anchor-link][href="${hash}"]`) : null;
    if (hashMatch) {
      setActiveLink(root, hashMatch);
      window.setTimeout(function () {
        scrollToHref(root, hash);
      }, 50);
      return;
    }

    const preset = root.querySelector('[data-anchor-link].is-active') || getLinks(root)[0];
    if (preset) setActiveLink(root, preset);
    updateActiveFromScroll(root);
  }

  function initAll() {
    document.querySelectorAll(selector).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector(selector);
    if (root) {
      root.dataset.anchorBound = 'false';
      initRoot(root);
    }
  });
})();
